import React from 'react';
import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type DataTableNoResultsProps = {
  children?: (query: string) => React.ReactNode;
};

export const DataTableNoResults: React.FC<DataTableNoResultsProps> = ({
  children,
}) => {
  const { tableState, isEmpty, isLoading, isError, hasSearchQuery } =
    useDataTableContext();

  if (!isEmpty || isLoading || isError || !hasSearchQuery) {
    return null;
  }

  const query = tableState.query ?? '';

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      minHeight="100px"
    >
      {children?.(query) ?? (
        <Copy variant="body" color="primaryText">
          No results matching "{query}"
        </Copy>
      )}
    </Flex>
  );
};
